// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeUmow_welcomeSection__cdIzF","welcomeContainer":"WelcomeUmow_welcomeContainer__+CRff","welcomeText":"WelcomeUmow_welcomeText__q+iac"};